import { Button, Checkbox, message, Modal, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { LuArrowUpDown } from "react-icons/lu";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import ErrorLogout from "../../../helpers/ErrorLogout";
import {
  addGroupMember,
  getAllMembers,
  getCompanyBuyer,
  removeGroupMember,
} from "../../../api/AdminRequest";
import moment from "moment";
import { IoPersonAddOutline, IoPersonRemoveOutline } from "react-icons/io5";

function BuyerList({ groupID }) {
  const [loader, setLoader] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(8);
  const [groupBuyerList, setGroupBuyerList] = useState([]);
  const [buyerList, setBuyerList] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [totalPages, setTotalPages] = useState(5);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [trigger, setTrigger] = useState(false);

  const [loaderD, setLoaderD] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  console.log(selectedIds);

  // This function will handle the checkbox change for individual checkboxes

  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      setSelectedIds((prevIds) => [...prevIds, id]); // Add the ID to the array
    } else {
      setSelectedIds((prevIds) =>
        prevIds.filter((selectedId) => selectedId !== id)
      ); // Remove the ID from the array
    }
  };

  // This function will handle the title checkbox change (select/deselect all)
  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setSelectedIds(tableData.map((item) => item._id)); // Select all items by adding all ids
    } else {
      setSelectedIds([]); // Deselect all items
    }
  };

  // Check if all checkboxes are selected
  const isAllSelected = tableData.every((item) =>
    selectedIds.includes(item._id)
  );

  const handleFilter = (data) => {
    const filteredBuyerList = data.filter(
      (buyer) =>
        !groupBuyerList.some((groupBuyer) => groupBuyer._id === buyer._id)
    );
    setBuyerList(filteredBuyerList);
  };

  const viewMemberList = () => {
    const buyerCall = async () => {
      try {
        setLoader(true);

        const { data } = await getCompanyBuyer();
        console.log(data, "data");

        if (data.success) {
          setLoaderD(false);
          handleFilter(data.buyerList);
        } else {
          setLoaderD(false);
        }
      } catch (error) {
        setLoaderD(false);

        console.log(error);
      }
    };
    buyerCall();
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      setTableData(buyerList);
    } else {
      setTableData(groupBuyerList);
    }
  }, [open, buyerList, groupBuyerList]);

  useEffect(() => {
    const groupCall = async () => {
      try {
        setLoader(true);
        const { data } = await getAllMembers(groupID, {
          page: currentPage,
          limit: limit,
        });

        console.log(data, "data in user");
        if (data?.success) {
          setGroupBuyerList(data?.groupMembersList);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    groupCall();
  }, [limit, currentPage, trigger, groupID]);

  const removeMember = async (selectedIds) => {
    Modal.confirm({
      title: "Confirm Action",
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you want to remove  this member?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        console.log(selectedIds, "selectedIds");

        try {
          const { data } = await removeGroupMember(groupID, {
            memberIds: selectedIds,
          });

          if (data.success) {
            message.success("Removed successfully");
            setTrigger(!trigger);
            setSelectedIds([]);

            // Refresh the user list or update the local state
          } else {
            message.error("Failed to remove");
            setTrigger(!trigger);
          }
          setTrigger(!trigger);
        } catch (error) {
          console.log("Error remove member:", error);
          message.error("An error occurred while removing member");
        }
      },
      onCancel() {
        console.log("Cancel");
        setSelectedIds([]);
      },
    });
  };
  const addMember = async (selectedIds) => {
    Modal.confirm({
      title: "Confirm Action",
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you want to Add  this member?`,
      okText: "Yes",
      okType: "primary",
      cancelText: "No",
      onOk: async () => {
        try {
          const { data } = await addGroupMember(groupID, {
            memberIds: selectedIds,
          });

          if (data.success) {
            message.success("Added successfully");
            setSelectedIds([]);
            setTrigger(!trigger);
            handleFilter(buyerList);
            // Refresh the user list or update the local state
          } else {
            message.error("Failed to Add");
            setTrigger(!trigger);
          }
          setTrigger(!trigger);
        } catch (error) {
          console.log("Error Add member:", error);
          message.error("An error occurred while adding member");
        }
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const columns = [
    {
      title: () => (
        <Checkbox
          onChange={handleSelectAllChange}
          checked={isAllSelected} // Title checkbox is checked if all items are selected
          indeterminate={selectedIds.length > 0 && !isAllSelected} // Indeterminate state if some, but not all, are selected
        />
      ),
      key: "select",
      render: (text, record) => (
        <Checkbox
          onChange={(e) => handleCheckboxChange(e, record._id)} // Individual checkbox change
          checked={selectedIds.includes(record._id)} // Mark checkbox as checked if the id is in selectedIds
        />
      ),
      width: 50,
    },
    {
      title: <div className="flex items-center gap-2">Name</div>,
      dataIndex: "name",
      key: "name",
      render: (text) => (
        <div className="flex items-center">
          {/* <img
                src={Userimg}
                alt="User avatar"
                className="w-8 h-8 rounded-full mr-2"
              /> */}
          <span className="text-[#313131] text-[13px] font-medium">{text}</span>
        </div>
      ),
    },
    {
      title: <div className="flex items-center gap-2">Email</div>,
      dataIndex: "email",
      key: "email",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">{text}</span>
      ),
    },
    {
      title: <div className="flex items-center gap-2">Phone</div>,
      dataIndex: "phone",
      key: "phone",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">{text}</span>
      ),
    },
    {
      title: <div className="flex items-center gap-2">Company Email</div>,
      dataIndex: "roleDetails",
      key: "roleDetails",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">
          {text?.companyEmail}
        </span>
      ),
    },
    {
      title: <div className="flex items-center gap-2">Status</div>,
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <span
          className={`px-2 py-1 rounded-full text-xs ${
            status === "active"
              ? "text-green-600"
              : status === "deactive"
              ? "text-red-600"
              : "text-gray-600"
          }`}
        >
          {status}
        </span>
      ),
    },

    {
      title: (
        <div className="flex items-center gap-2">
          Started Date
          <LuArrowUpDown className="text-[#9FACF0]" />
        </div>
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">
          {moment(text).format("DD MMM YYYY")}
        </span>
      ),
    },
    {
      title: "Actions",

      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-2">
          {open ? (
            <Tooltip title="Add">
              <Button
                onClick={() => {
                  addMember([record._id]);
                }}
                icon={<IoPersonAddOutline />}
                className="bg-green-500 text-white hover:border-[#FF4545]"
              />
            </Tooltip>
          ) : (
            <Tooltip title="Remove">
              <Button
                onClick={() => {
                  removeMember([record._id]);
                }}
                icon={<IoPersonRemoveOutline />}
                className="bg-[#FF4545] text-white hover:border-[#FF4545]"
              />
            </Tooltip>
          )}
        </div>
      ),
    },
  ];
  return (
    <div>
      <div className="flex justify-end p-2">
        {open ? (
          <div className="flex gap-4">
            {selectedIds.length > 0 && (
              <button
                className="px-4 py-2 text-[14px] md:text-[16px] font-medium text-white bg-[#1955EB] rounded-md hover:bg-white hover:border-[#1955EB] border-[1px] hover:text-[#1955EB]"
                onClick={() => {
                  addMember(selectedIds);
                }}
              >
                Add
              </button>
            )}{" "}
            <button
              className="px-4 py-2 text-[14px] md:text-[16px] font-medium text-white bg-[#1955EB] rounded-md hover:bg-white hover:border-[#1955EB] border-[1px] hover:text-[#1955EB]"
              onClick={onClose}
            >
              close
            </button>
          </div>
        ) : (
          <div className="flex gap-4">
            {selectedIds.length > 0 && (
              <button
                className="px-4 py-2 text-[14px] md:text-[16px] font-medium text-white bg-[#1955EB] rounded-md hover:bg-white hover:border-[#1955EB] border-[1px] hover:text-[#1955EB]"
                onClick={() => {
                  removeMember(selectedIds);
                }}
              >
                Remove
              </button>
            )}
            <button
              className="px-4 py-2 text-[14px] md:text-[16px] font-medium text-white bg-[#1955EB] rounded-md hover:bg-white hover:border-[#1955EB] border-[1px] hover:text-[#1955EB]"
              onClick={() => {
                viewMemberList();
              }}
            >
              + Add Members
            </button>{" "}
          </div>
        )}
      </div>
      <Table
        loading={loaderD}
        columns={columns}
        dataSource={tableData}
        pagination={{
          total: 200,
          current: current,
          pageSize: pageSize,
          showSizeChanger: false,
          itemRender: (page, type, originalElement) => {
            if (type === "prev") {
              return <p className="custom-pagination">Prev</p>;
            }
            if (type === "next") {
              return <p className="custom-pagination">Next</p>;
            }
            if (type === "page") {
              return <p className="custom-pagination">{page}</p>;
            }
            return originalElement;
          },
          onChange: (page, size) => {
            setCurrent(page);
            setPageSize(size);
          },
          showTotal: (total, range) =>
            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
          simple: true,
        }}
        className="custom-table-header lg:w-full w-[250px] overflow-x-auto custom-pagination"
      />
    </div>
  );
}

export default BuyerList;
